import { render } from "./Sidebar_v2.vue?vue&type=template&id=5379a993&scoped=true&ts=true"
import script from "./Sidebar_v2.vue?vue&type=script&lang=ts"
export * from "./Sidebar_v2.vue?vue&type=script&lang=ts"

import "./Sidebar_v2.vue?vue&type=style&index=0&id=5379a993&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5379a993"]])

export default __exports__